import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LoaderService {
  public readonly isShowSpinner$: Observable<boolean>;
  private readonly isShowSpinnerSubject: BehaviorSubject<boolean>;

  constructor() {
    this.isShowSpinnerSubject = new BehaviorSubject<boolean>(false);
    this.isShowSpinner$ = this.isShowSpinnerSubject.asObservable();
  }

  public show(): void {
    if (!this.isShowSpinnerSubject.getValue()) {
      this.isShowSpinnerSubject.next(true);
    }
  }

  public hide(): void {
    if (this.isShowSpinnerSubject.getValue()) {
      this.isShowSpinnerSubject.next(false);
    }
  }
}
